import {ThemeProvider} from '@primer/react-brand'
import {isFeatureEnabled} from '@github-ui/feature-flags'

import {FootnotesProvider} from '../../../components/contentful/ContentfulFootnotes/FootnotesContext'
import type {FlexPage} from '../../../schemas/contentful/contentTypes/flexTemplate'
import {PersonalizationProvider, type PersonalizationContextValue} from '../../../contexts/PersonalizationContext'

import {FlexTemplateContent} from './FlexTemplateContent'

export type FlexTemplateProps = {
  page: FlexPage
  userLoggedIn?: boolean
}

export function FlexTemplate({page, userLoggedIn}: FlexTemplateProps) {
  const footnotesEnabled = isFeatureEnabled('contentful_lp_footnotes')

  const personalizationValue: PersonalizationContextValue = {
    userState: {
      isLoggedIn: userLoggedIn,
    },
  }

  return (
    <ThemeProvider
      colorMode={page.fields.settings?.fields.colorMode ?? 'light'}
      style={{backgroundColor: 'var(--brand-color-canvas-default)'}}
    >
      <PersonalizationProvider value={personalizationValue}>
        {footnotesEnabled ? (
          <FootnotesProvider>
            <FlexTemplateContent page={page} />
          </FootnotesProvider>
        ) : (
          <FlexTemplateContent page={page} />
        )}
      </PersonalizationProvider>
    </ThemeProvider>
  )
}

try{ FlexTemplate.displayName ||= 'FlexTemplate' } catch {}